import { IconBoxOutline } from '@icons/IconBoxOutline'
import { IconCopyOutline } from '@icons/IconCopyOutline'
import { IconDictionaryOutline } from '@icons/IconDictionaryOutline'
import { IconHelpQuestionOutline } from '@icons/IconHelpQuestionOutline'
import { usePlatformOutletContext } from '../Platform/usePlatFormOutletContext'
import { useRestClient } from '@/contexts/QueryProvider'

const IconMap = {
  'data-templates': IconCopyOutline,
  'data-assets': IconBoxOutline,
  glossary: IconDictionaryOutline,
  faq: IconHelpQuestionOutline,
}

type SupportMenuProps = {
  setSupport: (key: string) => void
}

export function SupportMenu(props: SupportMenuProps) {
  const { appId, projectId } = usePlatformOutletContext()
  const { getUiApiGetSupportMenu } = useRestClient()

  const {
    data: supportMenu,
    isPending,
    isError,
  } = getUiApiGetSupportMenu.useQuery(
    {
      query: { applicationId: appId, projectId: projectId },
    },
    {
      staleTime: 24 * 60 * 60 * 1000, // 24 hours
    }
  )

  return (
    <>
      <div className="font-bold text-black">Support:</div>
      <div className="flex flex-col">
        {isPending || isError
          ? null
          : supportMenu.map((item) => {
              const Icon = item.key ? IconMap[item.key as keyof typeof IconMap] : null
              return (
                <button
                  className="inline-flex cursor-pointer items-center gap-x-2 text-grey-darkest hover:text-primary"
                  key={item.key}
                  onClick={() => props.setSupport(item.key ?? '')}
                >
                  {Icon && <Icon className="size-4" />}
                  {item.label}
                </button>
              )
            })}
      </div>
    </>
  )
}

export default SupportMenu
